// Screen `audit` — design/screens/AuditLog.dc.html — owner: S10, admin-ops (§9.19).
// Filters live in the URL so a filtered audit view can be shared and reloaded.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AuditPage } from '../../../features/access/AuditPage';
import { AuditSearch, compactAuditSearch } from '../../../features/access/audit-search';

export const Route = createFileRoute('/_settings/settings/audit')({
  validateSearch: AuditSearch,
  component: AuditRoute,
});

function AuditRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearch = (next: AuditSearch) =>
    void navigate({ to: '/settings/audit', search: compactAuditSearch(next), replace: true });
  return <AuditPage search={search} onSearch={onSearch} />;
}
